<template>
	<div>
		<v-dialog v-model="dialog_bank_details" no-click-animation persistent fullscreen scrollable max-width="500px" transition="dialog-bottom-transition">
	      <v-card flat style="padding-top:56px !important;">
	      	<v-toolbar flat fixed class="main_toolbar">
                <v-toolbar-side-icon @click="$parent.fn_closeDialog"><v-icon>arrow_back</v-icon></v-toolbar-side-icon>
                <v-toolbar-title>Bank Details</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn flat icon @click="fn_saveBankDetails">Done</v-btn>
            </v-toolbar>

	        <v-card-text dialog-card-content>
	            <v-layout wrap>
	            	<v-form data-vv-scope="fields" full-width>

                        <v-flex xs12 sm12 md12 form-item>
			               	<v-text-field  
			               		v-model="bankDetails.bankName.value" 
			               		:label="bankDetails.bankName.label" 
			               		placeholder=" ">
			               	</v-text-field>
			            </v-flex>

			            <v-flex xs12 sm12 md12 form-item>
			               	<v-text-field  
			               		v-model="bankDetails.branchName.value" 
			               		:label="bankDetails.branchName.label" 
			               		placeholder=" ">
			               	</v-text-field>
			            </v-flex>

			            <v-flex xs12 sm12 md12 form-item>
			               	<v-text-field  
			               		v-model="bankDetails.ifscCode.value" 
			               		:label="bankDetails.ifscCode.label" 	
			               		placeholder=" ">
			               	</v-text-field>
			            </v-flex>

	            		<v-flex xs12 sm12 md12 form-item>
			               	<v-text-field  
			               		v-model="bankDetails.accountName.value" 
			               		:label="bankDetails.accountName.label" 
			               		placeholder=" ">
			               	</v-text-field>
			            </v-flex>

			            <v-flex xs12 sm12 md12 form-item>
			               	<v-text-field  
			               		v-model="bankDetails.accountNumber.value" 
			               		:label="bankDetails.accountNumber.label" 
			               		placeholder=" ">
			               	</v-text-field>
			            </v-flex>

		            </v-form>
	            </v-layout>

	        </v-card-text>

	      </v-card>
	    </v-dialog>
	</div>
</template>

<script>
export default{
	data(){	
		return{
			dialog_bank_details: false,
			quillContent:null,
			bankDetails:{
				"accountName":{"label":"Account Name", "value":null}, 
				"accountNumber":{"label":"Account Number", "value":null},
				"bankName":{"label":"Bank", "value":null},
				"branchName":{"label":"Branch", "value":null}, 
				"ifscCode":{"label":"IFSC Code", "value":null}
			}
		}
	},
	methods:{
		openDialogWeb: function () {	
			this.errors.clear('fields');
			this.quillContent = this.$parent.$refs['ref_dialogQuill'].content;
			this.bankDetails = {
				"accountName":{"label":"Account Name", "value":null},
				"accountNumber":{"label":"Account Number", "value":null}, 
				"bankName":{"label":"Bank", "value":null},
				"branchName":{"label":"Branch", "value":null},
				"ifscCode":{"label":"IFSC Code", "value":null}, 
			}
			this.dialog_bank_details = true;
		},
		closeDialogWeb: function () {
			this.dialog_bank_details = false;
			let self = this;
            setTimeout(function(){
                self.$parent.$refs['ref_dialogQuill'].content = self.quillContent;
            },300);
		},
		fn_saveBankDetails: function () {
			let bankName = this.bankDetails.bankName.value ? "<p><b>"+this.bankDetails.bankName.label +"</b>: "+ this.bankDetails.bankName.value +"</p>" : '';
            let bankBranch = this.bankDetails.branchName.value ? "<p><b>"+this.bankDetails.branchName.label +"</b>: "+ this.bankDetails.branchName.value +"</p>" : '';
            let ifscCode = this.bankDetails.ifscCode.value ? "<p><b>"+this.bankDetails.ifscCode.label +"</b>: "+ this.bankDetails.ifscCode.value +"</p>" : '';
            let accountName = this.bankDetails.accountName.value ? "<p><b>"+this.bankDetails.accountName.label +"</b>: "+ this.bankDetails.accountName.value +"</p>" : '';
            let accountNumber = this.bankDetails.accountNumber.value ? "<p><b>"+this.bankDetails.accountNumber.label +"</b>: "+ this.bankDetails.accountNumber.value +"</p>" : '';
            this.quillContent += "<div>" + bankName + bankBranch + ifscCode + accountName + accountNumber + "</div>";
			this.$parent.fn_closeDialog();
		},
	}
}
</script>


// WEBPACK FOOTER //
// src/components/print_fields/dialogs/dialog_bank_details.vue